// extracted by mini-css-extract-plugin
export var dividerContainer = "_9g-0";
export var line = "_9g-1";